import useAuth from 'client/utils/auth/useAuth';
import { useIntl } from 'react-intl';
import Header from 'client/components/suc/Navbar/Header/Header';
import Logo from 'client/components/suc/Navbar/Logo/Logo';
import { Links, NavLink } from 'client/components/suc/Navbar/Links';
import Divider from 'client/components/suc/Navbar/Divider/Divider';
import SelectLocale from 'client/components/suc/Navbar/SelectLocale/SelectLocale';
import SignIn from 'client/components/suc/Navbar/SignIn/SignIn';
import SignOut from 'client/components/suc/Navbar/SignOut/SignOut';

import {
    BOOKMARKS_PAGE,
    HOME_PAGE,
    ENQUIRIES_PAGE,
    MAP_PAGE,
    WORKPACKS_PAGE,
    NETWORK_COVERAGE_PAGE,
    OBSERVATIONS_PAGE
} from 'client/utils/routes/routeConstants';

import { permissions } from 'client/utils/constants/permissions';
import { enquiryFeatureFlag } from 'client/utils/constants/frontEndConfig';

const Navbar = () => {
    const { permissions: userPermissions, isAuthenticated } = useAuth();
    const intl = useIntl();

    const hasPermission = (perm) => userPermissions?.includes(perm);

    const canViewMap = hasPermission(permissions.MAP_VIEW);
    const canViewEnquiries = hasPermission(permissions.ENQUIRY_VIEW);
    const canViewObservations = hasPermission(permissions.OBSERVATIONS_VIEW);

    return (
        <Header data-testid="navbar">
            <Logo data-testid="navbar.logo"/>
            <Links>
                <NavLink data-testid="navbar.link.home" to={HOME_PAGE}>
                    {intl.formatMessage({ id: 'navbar.link.home' })}
                </NavLink>

                {canViewMap && (
                    <>
                        <NavLink data-testid="navbar.link.map" to={MAP_PAGE}>
                            {intl.formatMessage({ id: 'navbar.link.map' })}
                        </NavLink>
                        <NavLink data-testid="navbar.link.bookmark" to={BOOKMARKS_PAGE}>
                            {intl.formatMessage({ id: 'navbar.link.bookmark' })}
                        </NavLink>
                        {canViewEnquiries && (
                            <NavLink data-testid="navbar.link.workpacks" to={WORKPACKS_PAGE}>
                                {intl.formatMessage({ id: 'navbar.link.workpacks' })}
                            </NavLink>
                        )}
                    </>
                )}

                {enquiryFeatureFlag && canViewEnquiries && (
                    <NavLink data-testid="navbar.link.listEnquiryPage" to={ENQUIRIES_PAGE}>
                        {intl.formatMessage({ id: 'navbar.link.listEnquiryPage' })}
                    </NavLink>
                )}

                {canViewObservations && (
                    <NavLink data-testid="navbar.link.observation" to={OBSERVATIONS_PAGE}>
                        {intl.formatMessage({ id: 'navbar.link.observation' })}
                    </NavLink>
                )}

                {isAuthenticated && (
                    <NavLink data-testid="navbar.link.network.coverage" to={NETWORK_COVERAGE_PAGE}>
                        {intl.formatMessage({ id: 'navbar.link.network.coverage' })}
                    </NavLink>
                )}

                <Divider/>
                <SelectLocale/>
                <Divider/>
                {isAuthenticated ? <SignOut/> : <SignIn/>}
            </Links>
        </Header>
    );
};

export default Navbar;
